export default {
    "logoLink": "https://www.atfx.com/zh-hant",//修改该参数请在/static/lang.js也需修改
    "FCA_License_No": "FCA 許可證",//修改该参数请在/static/lang.js也需修改
    "headTtitle": "外匯保証金交易真實帳戶_CFD差價合約真實帳戶_開設外幣交易帳戶 - ATFX.COM",//修改该参数请在/static/lang.js也需修改
    "topFixedBanner": "差價合約是複雜的金融交易產品，可帶來由槓桿作用而導致迅速虧損的高風險。 大部分的零售投資者帳戶在跟交易差價合約時錄得資金虧損。您應當考慮您是否充分明白差價合約如何運作，以及您是否能承受您的資金損失的高風險。",//修改该参数请在/static/lang.js也需修改
    "topFixedBannerShort": "59.38% 的零售投資者帳戶在跟這個供應商交易差價合約時錄得資金虧損。",//修改该参数请在/static/lang.js也需修改
    "headDescription": "外匯開戶首選ATFX，正規外匯平臺英國FCA監管。FCA監管號：760555，交易安全可靠、致力於為快速增長的客戶提供外匯、貴金屬、指數、差價合約和原油交易的服務。",
    "policyBarClose": '公司已決定不再面向零售客戶提供服務, 即時生效。故此不再接受零售客戶開戶申請。<br />對專業客戶的服務將不受影響。申請專業客戶請聯繫<a href="mailto:cs.uk@atfx.com">cs.uk@atfx.com</a>',
    "policyBar":'我們使用cookie以確保您在我們的網站獲得最佳體驗。繼續瀏覽本網站即表示您同意我方使用cookie。 <a title="【詳情】" href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Cookies%20Policy%20EN.pdf" target="_blanck">【詳情】</a>',
    "policyBarButton":'同意',
    "header": {
      "registration": "開戶申請",
      "personalDetails1": "個人資料1",
      "personalDetails2": "個人資料2",
      "financialDetails": "財務細節",
      "Experience": "經驗",
      "Knowledge": "知識",
      "Acknowledgements": "確認",
      "previewPage":"預覽",
      "liveTrading": "真實交易"
    },
    footer:{//修改该参数请在/static/lang.js也需修改
      "copyright":"© 2020 ATFX.COM. 版權所有。",
      "terms1":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf" target="_blank" rel="noopener">隱私政策</a>',
      "terms2":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Cookies%20Policy%20EN.pdf" target="_blank" rel="noopener">Cookie策略</a>',
      "terms3":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf" target="_blank" rel="noopener">條款和條件</a>',
      "Legal":"法律聲明: AT Global Markets (UK) Limited 為一家英國公司（公司註冊號：09827091），經英國金融行為監管局（FCA）授權並受其監管（FCA監管號：760555）。註冊地址是：1st Floor, 32 Cornhill, London, EC3V 3SG, United Kingdom。",
      "riskWaring":'高風險投資警告: 差價合約是複雜的金融交易產品，可帶來由於槓桿作用而導致迅速虧損的高風險。<strong>59.38% 的零售投資者帳戶在跟這個供應商交易差價合約時錄得資金虧損。</strong>您應當考慮您是否充分明白差價合約如何運作，以及您是否能承受您的資金損失的高風險。請閱讀 <a title="風險披露政策" href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf" target="_blanck">風險披露政策</a>.',
      "otherInfo":"本網站的信息不針對美國、比利時或英國境外任何特定國家的居民，也不得向當地法律法規禁止傳播或使用此信息的任何國家或地區的任何人傳播此信息或供其使用此信息。"
    },
    "headerMsg": {
      "personalDetails1": "當提交以下資訊，將表示確認並同意ATFX 的<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>商業條款</a>和<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>隱私政策</a>，ATFX會基於申請表的細節與我聯繫。",
      "personalDetails2": "當提交以下資訊，將表示確認並同意ATFX 的<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>商業條款</a>和<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>隱私政策</a>，ATFX會基於申請表的細節與我聯繫。",
      "financialDetails": "作為FCA授權及監管的公司，我們有責任評估我們的產品是否適合您。您提供的答案將成為我們能否為您提供服務的依據。",
      "experience": "作為FCA授權及監管的公司，我們有責任評估我們的產品是否適合您。您提供的答案將成為我們能否為您提供服務的依據。",
      "knowledge": "作為FCA授權及監管的公司，我們有責任評估我們的產品是否適合您。您提供的答案將成為我們能否為您提供服務的依據。",
      "acknowledgements": "完成提交本開戶表，即確認您已明白保證金外匯及差價合約是杠杆產品, 並會為您的投資本金帶來高風險。您確認已知悉監控帳戶情況屬本人的責任，且產品性質本身導致您可能會損失超過初始投資額。"
    },
    "changeLanguage": "切換語言",
    "back": "上一頁",
    "next": "下一頁",
    "finish": "完成",
    "personalDetails1": {
    "estimatedTime":"預計完成註冊的時間為5分鐘",
    "Gender": "性別",
      "genderSelect": {
        "M": "男士",
        "F": "女士",
        "O":"其他"
      },
      "OtherGender":"其他性别",
      "Title": "稱謂",
      "titleSelect":{
        "Mr":"先生(Mr.)",
        "Mrs":"太太(Mrs)",
        "Ms":"女士(Ms)",
        "Miss":"小姐(Miss)",
        "Dr":"博士(Dr)",
        "Other":"其他"
      },
      "OtherTitle":"其他稱謂",
      "First_Name": "名",
      "Surname": "姓",
      "Email": "電子郵箱地址",
      "Email_Confirm": "確認郵箱地址",
      "Lang": "郵箱語言",
      "emailLanguages": {
        "ENG": "英文",
        "CHT": "繁體中文",
        "CHS": "簡體中文",
        "ARA": "阿拉伯文",
        "ESP": "西班牙語",
        "ITA": "意大利語",
        "GER": "德語",
        "PTG": "葡萄牙語"
      },
      "MT4_Currency":"交易賬戶幣種",
      "MT4CurrencySelect":{
        "USD":"(USD) 美元",
        "GBP":"(GBP) 英鎊",
        "EUR":"(EUR) 歐元"
      },
      "Account_Type": "MT4賬戶類型",
      "Account_TypeSelect": {
        "CFDs": "CFDs",
        "SpreadBetting": "點差交易"
      },
      "Country": "居住地",
      "countrySelect": {
        "USA": "美國",
        "HKG": "香港",
        "GBR":"英國",
        "CHN":"中國",
        "TWN":"台灣",
        "ARE":"阿拉伯聯合大公國",
        "ALB":"阿爾巴尼亞",
        "AND":"安道爾",
        "AIA":"安圭拉",
        "ATG":"安提瓜和巴布達",
        "ARG":"阿根廷",
        "ARM":"亞美尼亞",
        "ABW":"阿魯巴",
        "AUS":"澳洲",
        "AUT":"奥地利",
        "AZE":"阿塞拜疆",
        "BHS":"巴哈馬",
        "BHR":"巴林",
        "BGD":"孟加拉共和國",
        "BRB":"巴巴多斯",
        "BLR":"白俄罗斯",
        "BEL":"比利時",
        "BLZ":"伯利茲",
        "BEN":"貝寧",
        "BMU":"百慕達",
        "BOL":"玻利維亞",
        "BWA":"博茨瓦納",
        "BVT":"波維特島",
        "BRA":"巴西",
        "BRN":"文萊",
        "BGR":"保加利亞",
        "BFA":"布基納法索",
        "BDI":"蒲隆地",
        "KHM":"柬埔寨",
        "CMR":"喀麥隆",
        "CPV":"佛得角",
        "CYM":"開曼群島",
        "CAF":"中非共和國",
        "TCD":"乍得",
        "CHL":"智利",
        "CCK":"科科斯群島",
        "COL":"哥倫比亞",
        "COM":"科摩邏",
        "COK":"庫克群島",
        "CRI":"哥斯達尼加",
        "CIV":"科特迪瓦",
        "HRV":"克邏地亞",
        "CUB":"古巴",
        "CYP":"塞浦路斯",
        "CZE":"捷克",
        "DNK":"丹麥",
        "DJI":"吉布提",
        "DMA":"多米尼克",
        "DOM":"多明尼加共和國",
        "EGY":"埃及",
        "SLV":"薩爾瓦多",
        "ERI":"厄立特里亞",
        "EST":"愛沙尼亞",
        "ETH":"埃塞俄比亞",
        "FJI":"斐濟",
        "FIN":"芬蘭",
        "PYF":"玻里尼西亞",
        "GAB":"加彭",
        "GEO":"格魯吉亞",
        "DEU":"德國",
        "GHA":"迦納",
        "GIB":"直布邏陀",
        "GRC":"希蠟",
        "GRL":"格陵蘭",
        "GRD":"格林納達",
        "GLP":"岡比亞",
        "GTM":"危地馬拉",
        "GIN":"幾內亞",
        "GNB":"幾內亞比紹",
        "HTI":"海地",
        "HMD":"赫德及麥當奴群島",
        "HND":"洪都拉斯",
        "HUN":"匈牙利",
        "ISL":"冰島",
        "IND":"印度",
        "IDN":"印度尼西亞",
        "IRL":"愛爾蘭",
        "ISR":"以色列",
        "ITA":"意大利",
        "JAM":"牙買加",
        "JPN":"日本",
        "JOR":"約旦",
        "KAZ":"哈薩克斯坦",
        "KEN":"肯尼亞",
        "KIR":"基里巴斯",
        "KOR":"南韓",
        "KWT":"科威特",
        "KGZ":"吉爾吉斯坦",
        "LVA":"拉脫維亞",
        "LSO":"萊索托",
        "LBR":"利比利亞",
        "LBY":"利比亞",
        "LIE":"列支敦士登",
        "LTU":"立陶宛",
        "LUX":"盧森堡",
        "MAC":"澳門特別行政區",
        "MDG":"馬達加斯加",
        "MWI":"馬拉維",
        "MYS":"馬來西亞",
        "MDV":"馬爾代夫",
        "MLI":"馬里",
        "MLT":"馬耳他",
        "MHL":"馬紹爾群島",
        "MTQ":"馬提尼克島",
        "MUS":"毛里求斯",
        "MYT":"馬約特島",
        "MEX":"墨西哥",
        "MDA":"摩爾多瓦",
        "MCO":"摩納哥",
        "MNG":"蒙古",
        "MNE":"蒙特內哥邏",
        "MSR":"蒙特塞拉特",
        "MAR":"摩洛哥",
        "MOZ":"莫桑比克",
        "NAM":"納米比亞",
        "NRU":"瑙魯",
        "NLD":"荷蘭",
        "NCL":"新喀里多尼亞",
        "NZL":"新西蘭",
        "NIC":"尼加拉瓜",
        "NER":"尼日爾",
        "NGA":"尼日利亞",
        "NIU":"紐埃",
        "NFK":"諾福克島",
        "NOR":"挪威",
        "OMN":"阿曼",
        "PAK":"巴基斯坦",
        "PSE":"巴勒斯坦",
        "PRY":"巴拉圭",
        "PER":"秘魯",
        "PHL":"菲律賓",
        "PCN":"皮特凱恩",
        "POL":"波蘭",
        "PRT":"葡萄牙",
        "QAT":"卡塔爾",
        "ROU":"邏馬尼亞",
        "RUS":"俄邏斯聯邦",
        "RWA":"盧旺達",
        "SHN":"聖赫勒拿",
        "KNA":"基茨-尼維斯",
        "LCA":"聖盧西亞",
        "SPM":"聖皮埃爾島及密克隆島",
        "VCT":"聖文森和格林那丁",
        "WSM":"薩摩亞",
        "SMR":"聖馬利諾",
        "STP":"聖多美和普林西比",
        "SAU":"沙特阿拉伯",
        "SEN":"塞內加爾",
        "SRB":"塞爾維亞",
        "SYC":"塞舌爾",
        "SLE":"塞拉利昂",
        "SGP":"新加坡",
        "SVK":"斯洛伐克共和國",
        "SVN":"斯洛文尼亞",
        "ZAF":"南非",
        "ESP":"西班牙",
        "SUR":"蘇里南",
        "SJM":"斯瓦巴及尖綿",
        "SWZ":"斯威士蘭",
        "SWE":"瑞典",
        "CHE":"瑞士",
        "TJK":"塔吉克斯坦",
        "TZA":"坦桑尼亞",
        "THA":"泰國",
        "TLS":"東帝汶",
        "TGO":"多哥",
        "TON":"東加",
        "TTO":"特立尼達和多巴哥",
        "TUN":"突尼斯",
        "TUR":"土耳其",
        "TKM":"土庫曼斯坦",
        "TCA":"特克斯和凱科斯群島",
        "TUV":"圖瓦盧",
        "UKR":"烏克蘭",
        "URY":"烏拉圭",
        "UZB":"烏茲別克斯坦",
        "VUT":"瓦努阿圖",
        "VAT":"梵蒂岡",
        "VEN":"委內瑞拉",
        "VNM":"越南",
        "WLF":"瓦利斯和富圖納",
        "ESH":"西撒哈拉",
        "ZMB":"贊比亞",
        "DZA": "阿爾及利亞",
        "AGO": "安哥拉",
        "BIH": "波斯尼亞和黑塞哥維那",
        "GMB": "岡比亞",
        "GUY": "圭亞那",
        "IRQ": "伊拉克",
        "RKS": "科索沃",
        "LBN": "黎巴嫩",
        "MKD": "馬其頓",
        "NPL": "尼泊爾",
        "PAN": "巴拿馬",
        "PNG": "巴布亞新幾內亞",
        "LKA": "斯里蘭卡"
      }
    },
    "personalDetails2": {
      "Addr": "地址 1",
      "Addr2": "地址 2",
      "City": "城市",
      "Postcode": "郵政編碼",
      "Building_Name": "樓房編號/名稱",
      "Street": "街道",
      "Province": "省份",
      "birthDate": "出生日期",
      "birthYear": "年",
      "birthMonth": "月",
      "birthSecond": "日",
      "Nationality": "證件簽發地",
      "isHavePass": "請問是否持有所選擇國籍的護照",
      "PotSelect": {
        "havePot": "有",
        "noPot": "否"
      },
      "NAT_ID": "護照號碼",
      "Phone": "電話",
      "countryPlace": "居住地",
      "TIN": "TIN（納稅人識別號碼）",
      "Doc_Type": "證件類型",
      "idTypeSelect": {
        "POT": "護照",
        "IDC": "身份證",
        "DRI": "駕照"
      },
      "Doc_No": "證件號碼",
      "bankCardType": "銀行卡類型",
      "bankCardTypeSelect": {
        "DR": "借記卡",
        "CR": "信用卡"
      },
      "Addr_Country":"地址所在國家",
      "Bank_Card_No": "銀行卡號",
      "bankCardNoConfirm": "銀行卡號確認",
      "Bank": "銀行",
      "bankSelect": {
        "ICBK": "中國工商銀行",
        "ABOC": "中國農業銀行",
        "PCBC": "中國建設銀行",
        "BKCH": "中國銀行",
        "CMBC": "招商銀行",
        "COMM": "交通銀行",
        "MSBC": "中國民生銀行",
        "EVER": "中國光大銀行",
        "SPDB": "上海浦東發展銀行",
        "FJIB": "興業銀行",
        "CIBK": "中信銀行",
        "PSBC": "中國郵政儲蓄銀行",
        "SZCB": "平安銀行",
        "GDBK": "廣東發展銀行",
        "BOSH": "上海銀行",
        "BJCN": "北京銀行",
        "HXBK": "華夏銀行",
        "other": "其他"
      },
      "OtherBank": "其它銀行",
      "Beneficiary_Name": "收款人",
      "SWIFT_Code": "SWIFT編碼",
      "Branch_Name": "銀行支行名稱",
      "Bank_Addr": "銀行分行地址",
      "Branch_Province": "銀行分行省份",
      "Branch_City": "銀行分行城市",
      "bankCardImg": "銀行卡附件",
      "IBAN_Code":"IBAN編碼",
      "docFrontImgword": "證件照片（正面）",
      "docBackImgword": "證件照片（反面）",
      "addressUpload": "地址証明",
      "addressUpload2": "地址証明2",
      "addressUploadTxt1": "可用證明：3個月之內的水電費清單/煤氣費單/銀行對帳單/暫住證/駕駛證/身份證/戶口本（如申請人不是戶主，需要連同戶主的頁面合併為1張圖片後提交）；",
      "addressUploadTxt2": "地址證明不得與身份證明相同。",
      "docImgword1": "證件附件1",
      "docImgword2": "證件附件2",
      "docImgword3": "證件附件3",
      "docImgword4": "證件附件4",
      "docImgword5": "證件附件5",
      "fileUpload":{
        "imgtUpload": "上傳",
        "uploadFileArr": [{
          "labelTxt": "身份附件1",
          "ValidateNull": "請選擇",
          "sizeLimit": "身份附件1不能超過5MB!"
        }, {
          "labelTxt": "身份附件2",
          "ValidateNull": "請選擇",
          "sizeLimit": "身份附件2不能超過5MB!"
        }, {
          "labelTxt": "地址証明",
          "ValidateNull": "請選擇",
          "sizeLimit": "請選擇地址證明附件大小應小於5MB!"
        },{
          "labelTxt": "地址証明2",
          "ValidateNull": "請選擇",
          "sizeLimit": "請選擇地址證明附件大小應小於5MB!"
        },{
          "labelTxt": "其他文件",
          "ValidateNull": "請選擇",
          "sizeLimit": "請選擇附件大小應小於5MB!!"
        }],
        "addressUploadHtml": {
          "sizeLimit":"檔案大小不可超過5MB",
          "upload_your_documents":"上傳您的身份證件",
          "documents_not_ready":"文件還沒有準備好?",
          "noe": "*申請人必須提供身份證件圖片和地址證明以核實身份。我們不接受：手機賬單，信用卡賬單或任何移動服務賬單;保險收據;購買商品/服務的發票。",
          "noe2":"如果您現在沒有所需的文件，您仍然可以完成申請。<br/><b>但是，在我們收到所需文件之前，您將無法進行交易。<b/>",
          "header1": "身份證明 (最少提交$Logic份)",
          "list1": "我們要求政府簽發的身份證/護照文件的彩色副本。對於身份證件，我們需要證件的正面和背面。",
          "list1_new":"我們要求護照正本的清晰彩色副本，而且需清楚看到護照的四個角。",
          "header2": "地址證明 (請從下列選項中提交$Logic份)",
          "list2": "<ol class='list-style-position:inside'><li>近3個月內發出的物業賬單 (水/電/煤氣), </li><li>近3個月由銀行發出的對賬單，</li><li>我們可以接受中國的戶口本和房產證，但須經過審核。 </li><li>當前的租賃協議以及近3個月內支付的物業賬單（煤氣/水/電）。 </li><li>在過去6個月內發布的稅單。 </li><li>在過去3個月內發出的固定電話賬單。 </li></ol>",
          "strongTxt":"<strong>作為我們監管要求的一部分，我們可能會要求您提供有關申請的其他文件。</strong>"
        }
      },
      "isHaveCitizen": "你是美國的公民嗎？",
      "CitizenSelect": {
        "Y": "是",
        "N": "否"
      },
      "citizen_Tip":"Unfortunatse cannot open an account for US citizens",
      "isDualCitizenship": "您是居住在您所在國家以外的任何地方的稅務居民嗎?",
      "DualCitizenshipSelect": {
        "Y": "是",
        "N": "否"
      },
      "Dual_Nationality":"國家",
      "IS_Politically_Person": "您是政治公眾人物嗎？",
      "IS_Politically_Exposed":'「政治公眾人物」是指在共和國或其他國家中，正在或曾經擔當重要公共職能的自然人，或其直系親屬，或已知與其有密切聯繫的人：<br/>此定義中的「重要公共職能」是指下列任何公共職能：<br/>（a）國家元首、政府首腦、部長、副部長或助理部長；<br/>（b）議會或類似立法機構的成員；<br/>（c）政党理事组织的成员；<br/>（d）最高法院、憲法法院或其他高級司法機構（除特殊情況外，不得就其判決或裁定提出上訴）的成員；<br/>（e）審計院或中央銀行董事會的成員；<br/>（f）大使、代辦以及武裝部隊中的高級官員；<br/>（g）國有企業的行政，管理或監督機構成員；<br/>（h）國際組織理事會或同等機構的理事、副理事和成員；<br/>（i）市長<br/>進一步而言，（a）至（i）中所提及的公共職能，不應理解為涵蓋中級或其他初級的官員；<br/>另一方面，「政治公眾人物」的近親屬包括：<br/>（a）政治公眾人物的配偶或被視為等同於配偶的人；<br/>（b）政治公眾人物的子女及其配偶、或被視為等同於其子女配偶的人；<br/>（c）政治公眾人物的父母；<br/>「已知與政治公眾人物有密切聯繫的人」是指下列自然人：<br/>（a）已知該自然人與政治公眾人物就法律實體、法律安排或任何其他密切商業關係擁有共同的實益所有權；<br/>（b）該自然人就法律實體或法律安排擁有單獨的實益所有權，但已知該法律實體或法律安排實際上是為了政治公眾人物的利益而設立的。',
      "IS_Politically_Person_Select": {
        "Y": "是",
        "N": "否"
      },
    },
    "financialDetails": {
      "Emp_Status": "就業狀態",
      "employmentStatusSelect": {
        "b": "受僱",
        "a": "自由職業",
        "c": "學生",
        "e": "退休",
        "d": "無業"
      },
      "Freelance_OwnACompany": "自由職業 / 個體商業戶",
      "Freelance_OwnACompany_select": {
        "0": "自由職業",
        "1": "個體商業戶"
      },
      "Position": "職位",
      "FD_Position_select": {
        "0": "首席經理，例如執行長、首席財務官、首席資訊官等",
        "1": "公司管理高層",
        "2": "高級/中級經理",
        "3": "部門經理",
        "4": "書記/秘書",
        "5": "一般員工",
        "6": "初級員工",
        "7": "其他（請說明）"
      },
      "Employer": "公司名稱",
      "Biz_Nature": "經營範圍",
      "financialRegulator": "您的僱主是否受FCA或其他金融機構監管?",
      "financialRegulatorSelect": {
        "Y": "是",
        "N": "否"
      },
      "Industry_Sector": "行業",
      "Industry_Sector_select": {
        "0": "會計",
        "1": "廣告媒體",
        "2": "電腦/互聯網/通訊/電子",
        "3": "教育/培訓",
        "4": "能源/原材料",
        "5": "金融服務（金融/銀行/保險)",
        "6": "政府/非營利組織",
        "7": "人力資源",
        "8": "法律",
        "9": "行銷",
        "10": "物流/交通",
        "11": "製藥/醫療",
        "12": "專業服務",
        "13": "房地產/建築",
        "14": "服務業",
        "15": "貿易/消費/製造/運營",
        "16": "其他（請注明）"
      },
      "Annual_Income": "您的年總收入",
      "Annual_Income_word":"一年內所有能賺取的收入，包括薪金、養老金、利息、紅利、租金等",
      "Total_Saving_Investments": "您的儲蓄和投資總額",
      "Total_Saving_word": "到目前為止所有的儲蓄和投資，包括銀行和投資平臺的存款、證券、基金、債券和其他投資等",
      "Total_Saving_Investments_select": {
        "0": "多於 US$500,000",
        "1": "US$200,000-US$499,999",
        "2": "US$100,000-US$199,999",
        "3": "US$50,000-US$99,999",
        "4": "US$25,000-US$49,999",
        "5": "US$10,000-US$24,999",
        "6": "US$2,000-US$9,999",
        "7": "少於 US$2,000"
      },
      "liquidNetWorth": "流動資金凈值（不包括私人物業）",
      "financialPortfolio": "您的金融投資組合總值",
      "annualIncomeSelect": {
        "0": "多於 US$200,000",
        "1": "US$100,000-US$199,999",
        "2": "US$50,000-US$99,999",
        "3": "US$25,000-US$49,999",
        "4": "US$10,000-US$24,999",
        "5": "少於 US$10,000"
      },
      "fundsSource": "這些資金的來源",
      "fundsSourceSelect": {
        "0": "無",
        "1": "家庭或伴侶收入",
        "2": "政府福利",
        "3": "貸款/信貸",
        "4": "養老金",
        "5": "租金收入",
        "6": "其他（請注明）"
      },
      "Funds_Source": "其他收入來源",
      "Intend_Deposit": "在ATFX的預計投資額為多少美元？",
      "intendDepositSelect": {
        "0": "多於 US$100,000",
        "1": "US$80,000 – US$99,999",
        "2": "US$50,000 – US$79,999",
        "3": "US$25,000 – US$49,999",
        "4": "US$10,000 – US$24,999",
        "5": "少於 US$10,000"
      },
      "Other_Industry_Sector": "其他行業/部門",
      "Other_Position": "其他職位",
      "Other_Biz_Nature": "其他經營範圍",
      "Other_Funds_Source": "其他收入來源",
      "Afford_To_Lose_Error":"差價合約 (CFDs) 屬高風險產品，您只應使用您可承受損失的資金來進行交易。",
      "Afford_To_Lose":"您可以承受您計劃投入的資金出現虧損嗎？",
      "Afford_To_Lose_Select": {
        "Y": "可以",
        "N": "不可以"
      },
      "Open_Trading_Account":"您為甚麼要在 ATFX 開立交易帳戶？",
      "Open_Trading_Account_Select": {
            "0": "在金融市場進行短期至中期投機",
            "1": "透過短期至中期的對沖抵銷現有的投資的風險",
            "2": "在金融市場進行短期至中期投機，同時藉對沖抵銷現有的投資的風險"
      },
      "ATFX_Client_Pro":"ATFX認為其產品僅適合具有上述目標的客戶。如果您的目標與上述目標不同，請放棄本次申請。",
      "Annual_Income_Total":"請提供您的實際年度收入",
      "Saving_Investments_Money":"請提供您的實際儲蓄和投資總額",
    },
    "Experience": {
      "experienceLabel": "在過去的三年中，您根據自己的交易策略交易以下產品的次數為多少？",
      "Futures_Options": "期貨/期權",
      "Futures_Options_select": {
        "0": "多於40次",
        "1": "15-40次",
        "2": "1-15 次",
        "3": "無"
      },
      "CFDs_Spread_Bets": "差價合約/外匯衍生品",
      "CFDs_Spread_Bets_select": {
        "0": "多於40次",
        "1": "15-40次",
        "2": "1-15 次",
        "3": "無"
      },
      "Derivative_Trade_over2": "在過去的十二個月裡，在您自己的交易決策下，您是否每季度對期現貨外匯/差價合約期權/期貨中至少進行過兩次交易？",
      "Derivative_Trade_over2_select": {
        "b": "是",
        "a": "否"
      },
      "Derivative_Trade_over40": "在過去三年中，您是否對現貨外匯/差價合約/期權/期貨在每年進行了至少四十次交易？",
      "Derivative_Trade_over40_select": {
        "b": "是",
        "a": "否"
      },
      "Average_Annual_Investment":"對於您選擇的上述金融產品，您過去平均每年用於交易的投資金額是多少？",
      "Average_Annual_Investment_select": {
        "0": "未投資過該產品",
        "1": "少於500美元 ",
        "2": "500至2,500美元",
        "3": "2500至10,000美元",
        "4": "超過10,000美元"
      },
      "Average_Leverage_Level":"對於您選擇的上述金融產品，您使用的平均槓桿水平是多少？",
      "Average_Leverage_Level_select": {
        "0": "未使用過槓桿",
        "1": "不超過1:10",
        "2": "1:10至1:25",
        "3": "1:25至1:50",
        "4": "1:50至1:100",
        "5": "1:100以上"
      }
    },
    "Knowledge": {
      "DT_Work_Experience": "您是否從事過金融衍生產品業務的工作並從此獲得相關的產品知識？",
      "DT_Work_Experience_select": {
        "txt1": "是",
        "txt2": "否",
        "subTxt1": "我至少有3年的工作經驗",
        "subTxt2": "我有不到3年的工作經驗，或者至少有一年以我的個人名義投資的經驗"
      },
      "DT_Qualification": "您是否有相關學位或資格證書證明您對衍生品交易有所了解？",
      "DT_Qualification_select": {
        "txt1": "是",
        "txt2": "否",
        "subTxt1": "我持有專業資格或學位，如CFA, MBA, BSC, MA等",
        "subTxt2": "我持有與金融，經濟，會計或相關領域相關的證書或者學位"
      },
      "K_Sell_Position": "您在1200的價格賣出一手黃金，現在價格上漲到1300， 請判斷您的這筆訂單是虧損還是盈利？",
      "K_Sell_Position_b": "您在1200的價格賣出一手XAUUSD.sb，現在價格上漲到1300，請判斷您的這筆訂單是虧損還是盈利？",
      "K_Sell_Position_select": {
        "0": "虧損",
        "1": "盈利"
      },
      "Closing_Order": "為了防止您的賬戶虧損大於您的預定數額，您將通過止損還是止盈來限制損失？",
      "Closing_Order_select": {
        "0": "止損",
        "1": "止盈"
      },
      "K_Profit_Change": "您是否理解通過槓桿交易CFD產品時，高槓桿意味著高風險？",
      "K_Profit_Change_b": "您是否理解通過槓桿交易CFDs/點差產品時，高槓桿意味著高風險？",
      "K_Profit_Change_select": {
        "0": "理解",
        "1": "不理解"
      },
      "K_Margin": "在槓桿為1：20的情況下，交易一手(100,000)美元/日元的佔用保證金是多少？",
      "K_Margin_select": {
        "0": "USD 5,000",
        "1": "USD 50,000",
        "2": "USD 100,000"
      }
    },
    "Acknowledgements": {
      "A1": "我確認提供給您的信息都是準確和完整的，並在此承諾該信息有任何改動會通知到您的；",
      "A2": "我已閱讀，理解並同意接受AT Global Markets (UK) Limited提供的客戶協議的約束;",
      "A2_txt": "客戶協議的約束",
      "A2_link": "<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>客戶協議的約束</a>",
      "A3": "我已閱讀，理解並同意接受AT Global Markets (UK) Limited提供的風險披露聲明書的約束；",
      "A3_txt": "客戶協議書",
      "A3_link": "<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>客戶協議書</a>",
      "A4": "我已閱讀，理解並同意接受AT Global Markets (UK) Limited提供的客戶協議執行政策和衝突政策;",
      "A4_txt": "客戶協議執行政策和衝突政策",
      "A4_link": "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Order%20Execution%20Policy%20EN%20-%20V10.18.pdf' target='_blank'>客戶協議執行政策</a>和<a href='https://www.atfx.com/uk/wp-content/uploads/conflict-of-interests-policy-uk-en.pdf' target='_blank'>衝突政策</a>",
      "header": "完成提交本開戶表，即確認您已明白保證金外匯及差價合約是杠杆產品, 並會為您的投資本金帶來高風險。您確認已知悉監控帳戶情況屬本人的責任，且產品性質本身導致您可能會損失超過初始投資額。",
      "age": "您確認已經年滿18歲。",
      "message": "您確認提供給的資訊都是準確和完整的，並在此承諾該資訊有任何改動會通知到我們。",
      "receive": {
        "text": "您已閱讀，理解並同意接受",
        "list": [
          "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf' target='_blank'>商業條款及風險聲明</a>",
          "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Order%20Execution%20Policy%20EN%20-%20V10.18.pdf' target='_blank'>訂單執行政策</a>",
          "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>隱私政策</a>",
          // "<a href='https://www.atfx.com/uk/wp-content/uploads/introducing-broker-disclosure-en.pdf' target='_blank'>介紹經紀商披露</a>",
          "<a href='https://www.atfx.com/zh-hant/legal' target='_blank'>關鍵信息文件</a>"
        ]
      },
      "A_select": {
        "text": "我已閱讀，理解並同意以上所有條款。",
        "Y": "我已閱讀，理解並同意以上所有條款。"
      },
      "checkboxTxt_A1": "我已閱讀，理解並同意以上所有條款",
      "checkboxTxt_A2": "我熟悉並理解差價合約是槓桿產品，其價格波動幅度很大",
      "checkboxTxt_A3": "我熟悉並理解操作和管理我的帳戶必須是我的個人行為和責任",
      "checkboxTxt_A4": "我熟悉並理解在交易槓桿產品時，損失可能會超過我的初始投資資金",
      "Marketing_Email_Preference": "我同意接收來自ATFX的資訊,其中可能包含營銷的內容",
      "Marketing_automatically": "我了解我可以通過聯繫<a href='https://www.atfx.com/zh-hant/about-us/contact-us' target='_blank'>客戶服務團隊</a>立即選擇不接收營銷傳播。",
      "Marketing_Email_Preference_select":{
        "Y":"同意",
        "N":"不同意"
      },
      "Hear_ATFX":"您是如何了解ATFX的?",
      "OtherHearATFX":"其他途徑",
      "hearATFXSelect":{
        "Recommendation":"推薦",
        "SearchEngine":"搜索引擎",
        "MediaAdvertising":"媒體廣告",
        "Partnership":"合作夥伴",
        "Other":"其他"
      },
      "Parent_IB_Code": "推薦人編號",
      "Rec_Type": "推薦人類型",
      "recTypeSelect": {
        "AA1": "AA1",
        "AA2": "AA2",
        "AA3": "AA3",
        "A01": "A01",
        "A02": "A02",
        "A03": "A03",
        "A00": "A00",
        "NAN": "無推薦人"
      },
      "recGroup": "組別",
      "recGroupSelect": {
        "A": "A",
        "AA": "AA"
      }
    },
    "customErrMsg": {
      "fieldIsRequired": {
        "Gender": "請選擇",
        "OtherGender":"請輸入其他性別",
        "Title": "請選擇",
        "OtherTitle":"請輸入其它稱謂",
        "First_Name": "請輸入名",
        "Surname": "請輸入姓",
        "Email": "請輸入電子郵件",
        "Email_Confirm": "請輸入電子郵件",
        "Lang": "請選擇",
        "Country": "請選擇",
        "MT4_Currency":"請選擇",
        "Account_Type":"請選擇",
        "Addr": "請輸入地址",
        "Addr2": "請輸入地址2",
        "City": "請輸入城市名稱",
        "Postcode": "請輸入郵政編碼",
        "Building_Name": "請輸入樓房編號/名稱",
        "Street": "請輸入街道",
        "Province": "請輸入省份",
        "Birth_Date_Year": "请選擇",
        "Birth_Date_Month": "请選擇",
        "Birth_Date_Day": "请選擇",
        "Nationality": "請選擇",
        "isHavePass": "請選擇",
        "NAT_ID": "請輸入護照號碼",
        "Phone": "請輸入電話",
        "Doc_Type": "請選擇",
        "Doc_No": "請輸入證件號碼",
        "Addr_Country": "請選擇",
        "Bank_Card_No": "請輸入銀行卡號",
        "Bank": "請選擇",
        "OtherBank": "請輸入其它銀行名稱",
        "Beneficiary_Name": "請輸入收款人",
        "Branch_Name": "請輸入分行名稱",
        "Bank_Addr": "請輸入開戶行名稱",
        "Branch_Province": "請輸入分行省份",
        "Branch_City": "请输入分行城市",
        "FD_Emp_Status": "請選擇",
        "FD_Position": "请输入職位",
        "FD_Employer": "请输入受雇公司名稱",
        "FD_Biz_Nature": "请输入業務屬性",
        "FD_FCA_AUTH": "請選擇",
        "FD_Annual_Income": "請選擇",
        "FD_Liquid_Net_Worth": "請選擇",
        "FD_Portfolio_Value": "請選擇",
        "FD_Funds_Source": "請選擇",
        "FD_Funds_Other": "请输入這些資金的其他來源",
        "E_Forex_Exp": "請選擇",
        "E_Forex_Trade_No": "請選擇",
        "E_Derivative_Exp": "請選擇",
        "E_Derivative_Trade_No": "請選擇",
        "E_Equity_Exp": "請選擇",
        "E_Equity_Trade_No": "請選擇",
        "K_A": "請選擇",
        "K_A_Detail": "請填寫詳情",
        "K_B": "請選擇",
        "K_B_Detail": "請填寫詳情",
        "K_C": "請選擇",
        "K_C_Detail": "請填寫詳情",
        "K_D": "請選擇",
        "K_E": "請選擇",
        "K_F": "請選擇",
        "K_G": "請選擇",
        "K_H": "請選擇",
        "A1": "請選擇",
        "A2": "請選擇",
        "A3": "請選擇",
        "A4": "請選擇",
        "checkList": "請選擇",
        "Emp_Status": "請選擇",
        "Freelance_OwnACompany": "請選擇",
        "Industry_Sector": "請選擇",
        "Position": "請選擇",
        "Employer": "请输入受雇公司名稱",
        "Biz_Nature": "请输入業務屬性",
        "Annual_Income": "請選擇",
        "Total_Saving_Investments": "請選擇",
        "Funds_Source": "請選擇",
        "Intend_Deposit": "請選擇",
        "Other_Industry_Sector": "請輸入其他行業",
        "Other_Position": "請輸入其他職位",
        "Other_Biz_Nature": "請輸入其他經營範圍",
        "Other_Funds_Source": "請輸入其他收入來源",
        "Futures_Options": "請選擇",
        "CFDs_Spread_Bets": "請選擇",
        "Derivative_Trade_over2": "請選擇",
        "Derivative_Trade_over40": "請選擇",
        "DT_Work_Experience": "請選擇",
        "DT_Qualification": "請選擇",
        "K_Sell_Position": "請選擇",
        "Closing_Order": "請選擇",
        "K_Profit_Change": "請選擇",
        "K_Margin": "請選擇",
        "IBAN_Code":"請輸入IBAN編碼",
        "Hear_ATFX":"請選擇",
        "OtherHearATFX":"請輸入",
        "Rec_Type":"請選擇",
        "Parent_IB_Code":"推薦人編號",
        "Afford_To_Lose":"请选择",
        "Open_Trading_Account": "請選擇",
        "Annual_Income_Total":"請輸入",
        "Saving_Investments_Money":"請輸入",
        "IS_Politically_Person":"請選擇",
        "isDualCitizenship":"請選擇",
      }
    },
    "errors": {
      "fieldIsRequired": "請輸入電子郵箱",
      "invalidFormat": "無效的格式！",
      "numberTooSmall": "該數值太小！最小值：{ 0 }",
      "numberTooBig": "該數值太大！最小值：{ 0 }",
      "invalidNumber": "無效號碼",
      "textTooSmall": "文字長度太短！當前：{ 0 }，最小：{ 1 }",
      "textTooBig": "文字長度太長！當前：{ 0 }，最小：{ 1 }",
      "thisNotText": "這不是文字！",
      "thisNotArray": "這不是一個數組！",
      "selectMinItems": "選擇最小{ 0 }項！",
      "selectMaxItems": "選擇最大{ 0 }項！",
      "invalidDate": "無效的日期！",
      "dateIsEarly": "日期太早了！當前：{ 0 }，最小：{ 1 }",
      "dateIsLate": "日期太晚了！當前：{ 0 }，最小：{ 1 }",
      "invalidEmail": "無效的電子郵箱的址",
      "invalidURL": "無效的URL！",
      "invalidCard": "無效的卡格式！",
      "invalidCardNumber": "無效卡號！",
      "invalidTextContainNumber": "無效的文字！不能包含數位或特殊字元。",
      "invalidTextContainSpec": "無效的文字！不能包含特殊字元",
      "incorrectComfirm": "兩次輸入不一致！",
      "invalidBirthDate": "只接受年齡從18-69歲的人士開戶",
      "invalidParentClnID": "請輸入小於12位數的數位！",
      "docImgFrontSizeLimit": "證件附件（正面）不能超過2MB!",
      "docImgBackSizeLimit": "證件附件（反面）不能超過2MB!",
      "imgSizeLimit": "請選擇地址證明附件圖片大小應小於2MB！",
      "bankCardNoTopTwo": "銀行卡號前兩位數位不符合",
      "bankCardNoLnegth": "請輸入16-19比特的數位",
      "dayErrors1": "該年為閏年，不存在該天",
      "dayErrors2": "該年為平年，不存在該天",
      "dayErrors3": "該月不存在該天",
      "emailError": "電子郵件不合法",
      "DocTypeNoError": "證件號碼格式不正確",
      "DocFrontImg": "請選擇證件附件（正面）",
      "DocBackImg": "請選擇證件附件（反面）",
      "ProofofAddress": "請選擇地址證明附件",
      "Doc_No": "請輸入證件號碼",
      "Phone": "請輸入電話",
      "Bank_Card_No": "請輸入銀行卡號",
      "Birth_Date_Second": "請輸入出生日期",
      "phoneError": "電話格式有誤",
      "bankNumError": "銀行卡格式不正確",
      "numType": "請輸入數字",
      "bankCodeError":"IBAN編碼格式不正確"
    },
    "messages": {
      "fieldsWillBeReset": "所有輸入將被重置，請確認",
      "completeTip1": "請檢查您的電子郵件。謝謝",
      "completeTip2": "已完成！謝謝",
      "noCompleteTip": "抱歉，您的輸入資訊有誤，上述操作未能成功",
      "emailAndDocInvalid": "電子郵箱已被使用",
      "phoneAndDocInvalid": "電話已被使用",
      "IBCodeInvalid": "推薦人代碼有誤",
      "invalidBankCardNo": "銀行卡號輸入有誤，請檢查後再提交",
      "beneficiaryName": "收款人必須與帳戶本人及銀行卡登記名稱一致",
      "employerName": "我們不會聯絡你雇主",
      "errors": "網絡有誤",
      "unSelect":"請選擇",
      "selectEmpStatusTip":"由於您選擇了退休，學生和無業中的一項，差價合約產品為高風險產品，為了保護您的切身利益，我們會根據您提供的其他材料審查您是否適合我們所提供的產品服務。"
    },
    "ModalMsg": {
      "showModal": {
        "content": "根據您在AT Global Markets Limited（UK）Limited客戶賬戶申請中提供的信息，我們有必要通知您差價合約(CFDs)和槓桿外匯交易可能不適合您。槓桿交易對您的資本帶來高風險。公司為客戶提供唯一的服務--執行，在交易時，您需要依靠自己的技能和判斷力。<br/><br/><b>請注意：AT Global Markets（UK）Limited提供模擬賬戶，您可以根據實際市場價格進行交易，我們鼓勵您在使用真實資金交易前先進行模擬賬戶操作。</b> <br/><br/>如果您仍希望在AT Global Markets（UK）Limited開設客戶賬戶，請通過接受以下聲明來確認。",
        "checkboxTxt": "我明白差價合約(CFDs)和槓桿外匯交易對我的資本造成了很大的風險。我能夠評估所涉及的風險，並希望繼續申請開設賬戶。",
         "errorsTxt": "請選擇",
        "btn": "確認"
      },
      "showAlert": {
        "title": "提示:",
        "submitBtnTxt": "確認",
        "cancleBtnTxt": "取消",
        "confirmBtnTxt": "確認"
      }
    },
    "ratesModalMsg": {
      "p3_1": "有關零售交易者保證金率變更的通告",
      "p3_2": "尊敬的申請者：",
      "p3_2_1": "您好！",
      "p3_3": "由於歐洲證券及市場管理局（European Securities and Markets Authority，ESMA）針對零售交易者變更保證金比率，所有從2018年7月2日起在ATFX申請開戶的新客戶，將採用新的保證金比率。",
      "p3_4": "這些變更包括向零售交易者實施槓桿上限。",
      "p4_1": "主要外匯: 3.33%（槓桿為30:1），包括下列任何兩種貨幣組成的貨幣對。美元（USD）、歐元（EUR）、日元（JPY）、 英鎊（GBP）、加元（CAD）、瑞郎（CHF）",
      "p4_2": "次要外匯: 5%（槓桿為20:1），包括主要外匯組合以外的所有其他貨幣對",
      "p4_3": "主要指標: 5%（槓桿為20:1），包括UK100，FRA40，ESP35，US30，SPX500，NAS100，JP225，AUS200",
      "p4_4": "黃金: 10%（槓桿為10:1）",
      "p4_5": "商品: 10%（槓桿為10:1）",
      "p5_1": "負結餘保護",
      "p5_2": "ESMA推出了一項新措施，旨在確保所有零售交易者不會損失超過其賬戶中的可動用資金金額。假如您的賬戶金額變為負數，根據新規定，ATFX有義務將您的賬戶餘額歸零，而您不用支付任何費用。",
      "p5_3": "50％保證金比例平倉準則",
      "p5_4": "這項50％保證金比例平倉準則已適用於所有ATFX客戶。",
      "p5_5": "如果您希望確定您的申請，並開立ATFX零售賬戶，請在下面的方格加上剔號。",
      "p5_6": "我明白並同意有關零售客戶的新條款。",
      "p6_2": "請同意",
      "btnText": "提交"
    },
    "verifyMsg": {
      "phone_exist": "此電子郵件地址已被使用，請使用其他電子郵件地址。",
      "email_exist": "此電話號碼已被使用，請使用其他電話號碼。",
      "phoneAndemail_exist": "電話號碼和電子郵件地址已被使用，請使用替代電話號碼和電子郵件地址。"
    }
  }



// WEBPACK FOOTER //
// ./src/lang/hk.js